import { CommonModule } from '@angular/common'
import {
  Component,
  OnDestroy,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import {
  ActivatedRoute,
  NavigationEnd,
  Route,
  Router,
  RouterModule,
} from '@angular/router'
import { RouteService } from '../../../services/route.service'
import { Subscription } from 'rxjs/internal/Subscription'

@Component({
  selector: 'app-product-side-menu',
  imports: [CommonModule, RouterModule],
  templateUrl: './product-side-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./product-side-menu.component.scss'],
})
export class ProductSideMenuComponent implements OnDestroy {
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private routeService = inject(RouteService)

  private subscription: Subscription
  private routeChangeSubscription: Subscription
  productId?: string
  currentUrl: string = ''
  routes: Array<Route> = []

  constructor() {
    this.subscription = this.route.params.subscribe((params) => {
      this.productId = params['id']
      if (!this.productId) {
        throw Error('invalid productId!')
      } else {
        this.currentUrl = this.router.url
        this.routes = this.routeService.getProductViewListWithId(
          this.productId!,
        )
      }
    })

    /* 
      This ensures that route changes outside of the sidebar are still
      captured and update the "active" sidebar link.
      E.g. The user clicking the "View Full Component Breakdown" link on the overview screen
    */
    this.routeChangeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url
      }
    })
  }

  // Unsubscribe from route params observable to prevent memory leaks
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    if (this.routeChangeSubscription) {
      this.routeChangeSubscription.unsubscribe()
    }
  }

  /**
   * Routes user to specified route
   */
  goToRoute(path: string | undefined) {
    if (path) {
      this.router.navigate([path])
      this.currentUrl = path
    }
  }
}
